/// <amd-module name="Test/ConfigurationToolbar/Store/ConfigurationToolbarStore" />
import * as CommonTypes from "Test/Analytics/Common/Types";
import { Store } from "VSS/Reflux/Store";
import { ConfigurationToolbarActions } from "../Actions/ConfigurationToolbarActions";

export interface IConfigurationToolbarState {
    reportConfigurationValues: CommonTypes.IReportConfiguration;
    isFilterBarVisible: boolean;
}

export class ConfigurationToolbarStore extends Store {
    private _state: IConfigurationToolbarState;

    constructor(private _actions: ConfigurationToolbarActions, reportConfigurationValues: CommonTypes.IReportConfiguration) {
        super("");
        this._initialize(reportConfigurationValues);
    }

    public getState(): IConfigurationToolbarState {
        return this._state;
    }

    public dispose(): void {
        this._actions.updateConfigurationValuesAction.removeListener(this._onUpdateConfiguration);
    }

    private _initialize(reportConfigurationValues: CommonTypes.IReportConfiguration): void {
        this._state = { reportConfigurationValues: reportConfigurationValues, isFilterBarVisible: false } as IConfigurationToolbarState;

        this._actions.updateConfigurationValuesAction.addListener(this._onUpdateConfiguration);
        this._actions.onToggleFilter.addListener(this._onToggleFilter);
    }

    private _onUpdateConfiguration = (newConfValues: CommonTypes.IReportConfiguration) => {
        this._state.reportConfigurationValues = { ...newConfValues };

        this.emitChanged();
    };

    private _onToggleFilter = () => {
        this._state.isFilterBarVisible = !this._state.isFilterBarVisible;

        this.emitChanged();
    };
}
